<script lang="ts">
	import ContainerLoading from "@hitit/hub/src/v7/components/common/ContainerLoading.svelte";
	import AppLayout from "../v7/layout/AppLayout.svelte";
	import UnlockForm from "./Atu/UnlockForm.svelte";
	import PostSuccess from "./Atu/PostSuccess.svelte";
	import { getAtu, postAtu } from "../utils/api";
	import { navigate } from "svelte-routing";

	//UI
	//Utils
	//Types
	//Props
	export let token: string | null = "";
	//Constants
	//Variables
	let status: "getLoading" | "getSuccess" | "postSuccess" = "getLoading";
	let getLoading = false;
	let storename: string;
	let requesterImage: string;
	let storeid: string;
	let id: string;
	let time = "";
	let posting = false;
	//Functions
	async function loadData(token: string | null) {
		try {
			if (token === null) throw new Error("Non Token");
			getLoading = true;
			const { data } = await getAtu(token);
			if (data.status !== "OK") throw new Error("Alerady Expire");
			id = data.appTempUnlockDTO.id;
			storeid = data.appTempUnlockDTO.storeId;
			requesterImage = data.appTempUnlockDTO.storageUrl;
			storename = data.appTempUnlockDTO.storeName || "";
			status = "getSuccess";
		} catch (error) {
			console.log(error);
			navigate("/error");
		} finally {
			getLoading = false;
		}
	}

	async function postData() {
		try {
			posting = true;

			await postAtu(token as string, id, storeid, time);
			status = "postSuccess";
		} catch (error) {
			alert("에러가 발생하였습니다. 다시 시도해주세요.");
		} finally {
			posting = false;
		}
	}
	//Do
	$: loadData(token);

</script>

{#if getLoading}
	<ContainerLoading alwaysCentermode />
{/if}
<AppLayout>
	<div slot="header" class="header">
		{#if status !== 'getLoading'}
			<p class="title">{storename}</p>
		{/if}
	</div>
	{#if status === 'getSuccess'}
		<UnlockForm
			bind:time
			on:click={postData}
			posting={posting}
			requesterImage={requesterImage}
			storename={storename} />
	{:else if status === 'postSuccess'}
		<PostSuccess time={time} />
	{/if}
</AppLayout>

<style lang="scss">
	.header {
		display: flex;
		width: 100%;
		justify-content: space-between;
		align-items: center;

		color: white;
		.title {
			font-weight: 500;
			font-size: 1.25rem;
		}
	}

</style>
